/**
 * Montant d'une visite (`visits.amount`) en CENTIMES.
 *
 * Toutes les visites sont écrites par les Cloud Functions (tap NFC, QR, validation
 * manuelle, réservation, caisse `payPosOrder`) avec un montant en centimes. Seules les
 * anciennes visites de caisse écrites par le navigateur avant payPosOrder
 * (`source: 'pos'`, sans `validationMethod`) le portaient en euros.
 */
export function visitAmountCents(v: { amount?: unknown; source?: unknown; validationMethod?: unknown } | null | undefined): number | null {
    if (!v || typeof v.amount !== 'number' || !Number.isFinite(v.amount) || v.amount <= 0) return null;
    const legacyPosEuros = v.source === 'pos' && !v.validationMethod;
    return Math.round(legacyPosEuros ? v.amount * 100 : v.amount);
}
